import { useMemo } from 'react';
import { useNetwork as useWagmiNetwork } from 'wagmi';

import { CHAIN_ID_TO_KEY_MAP, CHAIN_ID_TO_TYPE_MAP } from '../lib';

export const useNetwork = () => {
  const { chains, chain } = useWagmiNetwork();

  return useMemo(() => {
    const chainType =
      CHAIN_ID_TO_TYPE_MAP[chain?.id as keyof typeof CHAIN_ID_TO_TYPE_MAP];
    const chainKey =
      CHAIN_ID_TO_KEY_MAP[chain?.id as keyof typeof CHAIN_ID_TO_KEY_MAP];

    return {
      chains,
      chain,
      chainKey,
      chainType,
      isUnsupported: Boolean(chain && !chainKey),
    };
  }, [chains, chain]);
};
